var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.625,
    stroke: "#202124",
    strokeOpacity: 0.15,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11C12.8422 11.0039 12.7069 11.0548 12.5851 11.1606L9.15333 14.2086C9.05411 14.2987 9 14.4045 9 14.5338C9 14.7963 9.2345 15 9.53664 15C9.68095 15 9.81623 14.9491 9.91995 14.859L13 12.1166L16.08 14.859C16.1838 14.9491 16.3145 15 16.4634 15C16.7655 15 17 14.7963 17 14.5338C17 14.4084 16.9459 14.2987 16.8467 14.2086L13.4104 11.1606C13.2931 11.0509 13.1578 11 13 11Z",
    fill: "#202124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowZones);
export default __webpack_public_path__ + "static/media/show-zones.8eec28f48f9a7e165a9915e3d2743866.svg";
export { ForwardRef as ReactComponent };